function capitalize (item: string) {
  if (item) return item?.charAt(0).toUpperCase() + item.slice(1);
}

export default capitalize
